// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"eb3eabda","318":"e6495e91"}[chunkId] + ".chunk.js";
};